import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress harmless ResizeObserver loop error (Radix UI)
const _origOnError = window.onerror;
window.addEventListener("error", (e) => {
  if (e.message?.includes("ResizeObserver loop")) { e.stopImmediatePropagation(); e.preventDefault(); }
});

// Suppress cross-origin SecurityError from React DevTools in preview/dev
const origError = console.error;
console.error = (...args) => {
  if (typeof args[0] === "string" && args[0].includes("cross-origin")) return;
  origError.apply(console, args);
};

const container = document.getElementById("root");
if (!container) {
  const div = document.createElement("div");
  div.id = "root";
  document.body.appendChild(div);
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
